import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_RELEASE_MUTATION = graphql(/* GraphQL */ `
  mutation NegotiationCaseRelease($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        release
      }
    }
  }
`);
